import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonDimensions, RowData } from 'src/app/models/collection.interface';
import { CollectionsService } from 'src/app/services/collections.service';
import { RowDialogComponent } from '../row-dialog/row-dialog.component';

interface CustomCellRendererParams extends ICellRendererParams {
  adminMode: boolean;
  onRowUpdate?: (fileId: string, updatedData: Partial<CommonDimensions>) => void;
  isDisabled?: (d: RowData) => boolean;
}
@Component({
  selector: 'app-row-details',
  templateUrl: './row-details.component.html',
  styleUrl: './row-details.component.scss'
})
export class RowDetailsComponent implements ICellRendererAngularComp {
  dialog = inject(MatDialog);
  params = {} as CustomCellRendererParams;
  adminMode = false;
  private readonly LOCKED = new Set(['started', 'image_extraction', 'text_extraction', 'failed']);

  constructor(
    private collectionsService: CollectionsService,
    private snackBar: MatSnackBar
  ) {}

  // Params are passed in by ag-Grid
  agInit(params: CustomCellRendererParams): void {
    this.params = params;
    this.adminMode = params.adminMode || false;
  }

  refresh(): boolean {
    return false;
  }

  onClick(): void {
    const dialogRef = this.dialog.open(RowDialogComponent, {
      width: '1000px',
      data: {
        dimensions: this.params.data,
        adminMode: this.adminMode
      }
    });

    // Handle dialog result for admin mode
    if (this.adminMode) {
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'save') {
          this.handleSaveChanges(result.data);
        }
      });
    }
  }

  private handleSaveChanges(editedData: Partial<CommonDimensions>): void {
    if (!this.params.onRowUpdate) {
      console.warn('No onRowUpdate callback provided');
      return;
    }
    if (!this.params.data.file_id) {
      console.warn('Missing file_id in data');
      return;
    }
    this.params.onRowUpdate(this.params.data.file_id, editedData);
  }

  downloadSelectedDocuments(): void {
    const document = this.params.data;
    const collectionId = document['collection_id'].split('#')[1];
    this.collectionsService.downloadFileFromCollection(collectionId, document['original_document_uri']).subscribe({
      next: ({ file_name, url }) => {
        this.snackBar.open(`Opening ${file_name}`, 'Close', {
          duration: 10000
        });
        setTimeout(() => window.open(url, '_blank'), 2000);
      },
      error: error => {
        console.error('Error downloading document:', error);
        this.snackBar.open('Error downloading document', 'Close', {
          duration: 3000
        });
      }
    });
  }

  get locked(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const node = (this.params as any)?.node;

    if (node?.rowPinned) return true;

    const s = (this.params?.data?.processing_stage || '').toLowerCase().trim();
    return this.LOCKED.has(s);
  }
}
